import { createInteractor } from './interactor';
import { createView } from './view';
import { createLogger } from './logger';

const { log } = createLogger('[PRESENTER]');

export const buildHeader = ({ container, interactors = {} }) => {
  const view = createView({ container });
  const interactor = createInteractor({ interactors });

  const disconnect = interactor.connect(state => {
    const presenter = {
      analytics: interactor.analytics,
      actions: interactor.actions,
      state,
    };
    log(presenter);
    view.render(presenter);
  });

  return {
    ...interactor,
    destroy() {
      disconnect();
      view.destroy();
      interactor.destroy();
    },
  };
};
